import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import InvoicePrint from './Estimate';
import NongstBillPrint from './Bill';

function DashboardSaleInvoice() {
    const history = useHistory();
    const { id } = useParams();
    const [successMessage, setSuccessMessage] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [isReprinted, setisReprinted] = useState("");
    const [selectedCustomerData, setSelectedCustomerData] = useState(null);
    //            const response = await fetchData('OrderConfirmedApi', `/${companyId}/${selectedOption.value}`, token);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            fetchtableDatas();
            fetchtrips();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchtableDatas();
    }, []);

    useEffect(() => {
        fetchtrips();
    }, []);

    const [TripAllocateData, setTripallocateData] = useState([]);
    const [saleOrderId, setSaleOrderId] = useState('');


    const fetchtableDatas = async () => {
        try {
            //   const response = await fetchData('TripAllocateApi', `/${id}`, token);
            const response = await fetchData('OrderConfirmedApi', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setTripallocateData(response.response_data);
                setData(response.response_data);
                setSaleOrderId(response.response_data.id);
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    const handleHistoryClick = async (saleorderid) => {
        try {
            const response = await fetchData('VehicleApi', `/${companyId}/${saleorderid}`, token);
            if (response.responseCode === '1111') {
                setSelectedCustomerData(response.response_data);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };


    const [selectedItems, setSelectedItems] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    // Handle individual checkbox change
    const handleCheckboxChange = (event, itemId) => {
        if (event.target.checked) {
            setSelectedItems((prevItems) => [...prevItems, itemId]);
        } else {
            setSelectedItems((prevItems) => prevItems.filter(id => id !== itemId));
            setSelectAllChecked(false); // Uncheck "Select All" if any item is unchecked
        }
    };

    // Handle "Select All" checkbox change
    const handleSelectAllChange = (event) => {
        const isChecked = event.target.checked;
        setSelectAllChecked(isChecked);

        if (isChecked) {
            // Add only unfinished items to the selection
            const unfinishedItemIds = data
                .filter(item => !item.isFinished)
                .map(item => item.id);
            setSelectedItems(unfinishedItemIds);
        } else {
            // Clear selection if "Select All" is unchecked
            setSelectedItems([]);
        }
    };

    // GST Button Click
    const handlegstButtonClick = async () => {
        try {
            if (selectedItems.length === 0) {
                console.error("No items selected");
                return; // Prevent API call if no items are selected
            }

            const Saleorderdata = selectedItems.map(itemId => {
                const selectedItem = data.find(item => item.id === itemId);
                return {
                    Id: selectedItem.id,
                    CompanyId: companyId,
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                    IsGST: true,
                    TaxMethod: 1,
                };
            });

            const GSTinvoiceItems = { invoicedItems: Saleorderdata };

            setIsLoading(true); // Set loading state
            const response = await postData('InvoicedItemApi', GSTinvoiceItems, token);
            console.log('Invoice Created success:', response);

            history.push(`/DashboardSaleInvoice/${id}`);
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Invoice Create error:', error);
        } finally {
            setIsLoading(false); // Reset loading state
        }
        console.log("GST button clicked");
    };

    const handleEstimateGSTButtonClick = async () => {
        try {
            let Saleorderdata = [];
            if (selectAllChecked) {
                Saleorderdata = data.map(item => ({
                    Id: item.id,
                    CompanyId: companyId,
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                    IsGST: true,
                    TaxMethod: 2,
                }));
            } else {
                Saleorderdata = selectedItems.map(itemId => {
                    const selectedItem = data.find(item => item.id === itemId);
                    return {
                        Id: selectedItem.id,
                        CompanyId: companyId,
                        CreatedBy: userId,
                        CreatedDate: new Date(),
                        IsGST: true,
                        TaxMethod: 2,
                    };
                });
            }

            const GSTinvoiceItems = {
                invoicedItems: Saleorderdata,
            };

            setIsLoading(true); // Set loading state
            const response = await postData('InvoicedItemApi', GSTinvoiceItems, token);
            console.log('Invoice Created success:', response);
            // history.push('/SaleInvoice');
            history.push(`/DashboardSaleInvoice/${id}`);
            setTimeout(() => {
                window.location.reload()
            }, 3000);
        } catch (error) {
            console.error('Invoice Create error:', error);
        } finally {
            setIsLoading(false); // Reset loading state
        }
        console.log("GST button clicked");
    };

    const handleiNVOICEButtonClick = async () => {
        try {

            let Saleorderdata = [];
            if (selectAllChecked) {
                Saleorderdata = data.map(item => ({
                    Id: item.id,
                    CompanyId: companyId,
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                    IsGST: false,
                    TaxMethod: 3,
                }));
            } else {
                Saleorderdata = selectedItems.map(itemId => {
                    const selectedItem = data.find(item => item.id === itemId);
                    return {
                        Id: selectedItem.id,
                        CompanyId: companyId,
                        CreatedBy: userId,
                        CreatedDate: new Date(),
                        IsGST: false,
                        TaxMethod: 3,
                    };
                });
            }

            const nonGSTinvoiceItems = {
                invoicedItems: Saleorderdata,
            };

            setIsLoading(true); // Set loading state
            const response = await postData('SaleApi', nonGSTinvoiceItems, token);
            console.log('Invoice Created success:', response);
            // history.push('/SaleInvoice');
            history.push(`/DashboardSaleInvoice/${id}`);
            setTimeout(() => {
                window.location.reload()
            }, 3000);
        } catch (error) {
            console.error('Invoice Create error:', error);
        } finally {
            setIsLoading(false); // Reset loading state
        }
    };

    const handleSaleOrderPrint = async (SaleOrderid) => {
        try {
            // Fetch data
            const response = await fetchData('SaleOrderApi', `/SaleorderPrint/${SaleOrderid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                labelData[0].SaleOrderPrint.IsGST === true ? (
                    <InvoicePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ) : (
                    <NongstBillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />
                ),
                iframeDocument.body
            );


            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();


            try {
                await SyncData('SaleOrderApi', `${SaleOrderid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }


    };
    // Trip datas
    const [Tripdata, setTripData] = useState([]);

    const [TripDate, setTripDate] = useState('');
    const [OrderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with current date
    const [RouteId, setRouteId] = useState('');

    const [TripNo, setTripNo] = useState('');
    const [Description, setDescription] = useState('');
    const [CreatedBy, setCreatedBy] = useState('');
    const [CreatedDate, setCreatedDate] = useState('');
    const [IsActive, setIsActive] = useState('');
    const [IsTripFinish, setIsTripFinish] = useState('');

    const fetchtrips = async () => {
        try {


            const response = await fetchData('TripApi', `/tripdetails/${id}`, token);
            if (response.responseCode === '1111') {
                setTripData(response.response_data);
                setTripDate(response.response_data.TripDate);
                setOrderDate(response.response_data.OrderDate);
                setRouteId(response.response_data.RouteId);
                setTripNo(response.response_data.TripNo);
                setDescription(response.response_data.Description);
                setCreatedBy(response.response_data.CreatedBy);
                setCreatedDate(response.response_data.CreatedDate);
                setIsActive(response.response_data.IsActive);
                setIsTripFinish(response.response_data.IsTripFinish);

                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };



    //vehicletype

    const [vehicletypeId, setvehicletypeId] = useState('');
    const [vehicletypeOptions, setvehicletypeOptions] = useState([]);
    const [selectedvehicletype, setSelectedvehicletype] = useState(null);


    useEffect(() => {
        const fetchVehicleTypes = async () => {
            try {
                const response = await fetchData('VehicleTypeApi', `/${companyId}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(vehtype => ({
                        value: vehtype.id,
                        label: vehtype.name
                    }));
                    setvehicletypeOptions(options);
                }
            } catch (error) {
                console.error('Error fetching vehicle models:', error);
            }
        };

        fetchVehicleTypes();
    }, [companyId, token]);



    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '95%' }}>
            {successMessage && <p className="text-Black-500">{successMessage}</p>}
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>INVOICE</h6>
                <div className="w-1/4 mr-2" style={{ marginTop: '-10px' }}>
                    {/* Conditionally render buttons */}
                    {data.some(item => !item.isFinished) && (
                        <div>
                            <Tooltip title="Make GST INVOICE">
                                <Button onClick={handlegstButtonClick} style={{ backgroundColor: '#E6B9DE', color: 'black', fontWeight: 'bolder', cursor: 'pointer' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "GST BILL"}
                                </Button>
                            </Tooltip>
                            <Tooltip title="Make TAX BILL">
                                <Button onClick={handleEstimateGSTButtonClick} style={{ backgroundColor: 'darksalmon', color: 'black', fontWeight: 'bolder', cursor: 'pointer', marginLeft: '10px' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "TAX BILL"}
                                </Button>
                            </Tooltip>
                            <Tooltip title="Make INVOICE">
                                <Button onClick={handleiNVOICEButtonClick} style={{ backgroundColor: 'lightcoral', color: 'black', fontWeight: 'bolder', marginLeft: '10px', cursor: 'pointer' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "ESTIMATE BILL"}
                                </Button>
                            </Tooltip>
                        </div>
                    )}
                </div>

            </div>
            <br />

            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto', marginTop: '-20px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#243642' }}>
                            <TableRow>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', width: '50px' }}>Order.No</TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', width: '50px' }}>Rsequence.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Customer</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke' }}>Contact No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke' }}>Order Type</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke' }}>Order Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke' }}>No:Of Product</TableCell>

                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left' }}>
                                    <Tooltip title="Generate All Invoice">
                                        <input type="checkbox" onChange={handleSelectAllChange} checked={selectAllChecked} style={{ height: '17px', textAlign: 'left', cursor: 'pointer' }} />
                                    </Tooltip>
                                </TableCell>


                            </TableRow>
                        </TableHead>

                        <TableBody style={{ backgroundColor: '#FEF9F2' }}>
                            {/* Actual Orders Section */}
                            <TableRow>
                                <TableCell colSpan={7} sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bolder', textAlign: 'center' }}>
                                    Actual Orders
                                </TableCell>
                            </TableRow>
                            {data.filter(item => item.orderType === 1).map(item => (
                                <TableRow key={item.id}>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                        {item.routeseqNo}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>
                                        <a href="#" onClick={() => handleHistoryClick(item.id)} className="tooltip-link">
                                            <h6 style={{ fontFamily: 'Times New Roman', color: 'black', cursor: 'pointer' }}>
                                                {`${item.customerName || ''} ${item.addressLine1 || ''} ${item.customerCode || ''}`.trim()}
                                            </h6>
                                        </a>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px' }}>
                                        {item.phone}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'green', padding: '3px' }}>
                                        Actual Order
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'orangered', padding: '3px' }}>
                                        {new Date(item.orderDate).toLocaleDateString('en-GB')}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'darkmagenta', padding: '3px', fontWeight: 'bolder' }}>
                                        {item.itemcount}
                                    </TableCell>
                                    {item.isFinished === false ? (
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'black',
                                                padding: '3px',
                                                textAlign: 'left',
                                                height: '35px',
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                onChange={(event) =>
                                                    handleCheckboxChange(event, item.id)
                                                }
                                                checked={selectedItems.includes(item.id)}
                                                style={{ height: '17px', textAlign: 'left' }}
                                            />
                                        </TableCell>
                                    ) : (
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'black',
                                                padding: '3px',
                                                textAlign: 'left',
                                                height: '35px',
                                            }}
                                        >
                                            <Tooltip title="Generate the Sale Bill">
                                                <Button
                                                    onClick={() => handleSaleOrderPrint(item.id)}
                                                    style={{
                                                        backgroundColor: 'orange',
                                                        color: 'whitesmoke',
                                                        height: '25px',
                                                    }}
                                                >
                                                    Print Invoice
                                                </Button>
                                            </Tooltip>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}

                            {/* Additional Orders Section */}
                            <TableRow>
                                <TableCell colSpan={7} sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bolder', textAlign: 'center' }}>
                                    Additional Orders
                                </TableCell>
                            </TableRow>
                            {data.filter(item => item.orderType === 2).map(item => (
                                <TableRow key={item.id}>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'center' }}>
                                        {item.routeseqNo}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'left' }}>
                                        <a href="#" onClick={() => handleHistoryClick(item.id)} className="tooltip-link">
                                            <h6 style={{ fontFamily: 'Times New Roman', color: 'black', cursor: 'pointer' }}>{item.customerName}</h6>
                                        </a>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', fontSize: '16px' }}>
                                        {item.phone}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'blue', padding: '3px' }}>
                                        Additional Order
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'orangered', padding: '3px' }}>
                                        {new Date(item.orderDate).toLocaleDateString('en-GB')}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'darkmagenta', padding: '3px', fontWeight: 'bolder' }}>
                                        {item.itemcount}
                                    </TableCell>
                                    {item.isFinished === false ? (
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'black',
                                                padding: '3px',
                                                textAlign: 'left',
                                                height: '35px',
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                onChange={(event) =>
                                                    handleCheckboxChange(event, item.id)
                                                }
                                                checked={selectedItems.includes(item.id)}
                                                style={{ height: '17px', textAlign: 'left' }}
                                            />
                                        </TableCell>
                                    ) : (
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #F5F5F5',
                                                color: 'black',
                                                padding: '3px',
                                                textAlign: 'left',
                                                height: '35px',
                                            }}
                                        >
                                            <Tooltip title="Generate the Sale Bill">
                                                <Button
                                                    onClick={() => handleSaleOrderPrint(item.id)}
                                                    style={{
                                                        backgroundColor: 'orange',
                                                        color: 'whitesmoke',
                                                        height: '25px',
                                                    }}
                                                >
                                                    Print Invoice
                                                </Button>
                                            </Tooltip>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
            <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                <div className="fixed inset-0 flex items-start justify-center z-10 ">
                    <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                        <div className="flex justify-end mt-2">
                            <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                <Tooltip title="Close">
                                    <FaTimes />
                                </Tooltip>
                            </button>
                        </div>
                        <h6 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: '#347928', fontWeight: 'bolder' }}>ORDERED ITEMS</h6>

                        <div className="used-items-container">

                            <TableContainer component={Paper} style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
                                <table className="table" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '10%', fontSize: '14px' }}>Sl.No</th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Name</th>
                                            <th style={{ width: '7%', fontSize: '14px' }}>Qty(No.Pieces)</th>
                                            <th style={{ width: '7%', fontSize: '14px' }}>T.Qty
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Kgs)</p>
                                            </th>
                                            <th style={{ width: '12%', fontSize: '14px' }}>Rate
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Per Kg)</p>
                                            </th>
                                            <th style={{ width: '15%', fontSize: '14px' }}>Discount
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Per Item)</p>
                                            </th>
                                            <th style={{ width: '12%', fontSize: '14px' }}>Rate
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(After Discount)</p>
                                            </th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Taxable <span style={{ fontSize: '12px' }}>Amt</span></th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>GST <span style={{ fontSize: '12px' }}>Amt</span></th>
                                            <th style={{ width: '20%', fontSize: '14px' }}>Total <span style={{ fontSize: '12px' }}>Amt</span></th>
                                        </tr>
                                    </thead>
                                    {/* <tbody>
                                        {selectedCustomerData && selectedCustomerData.map((item, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{index + 1}</td>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{item.item}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.quantity}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.totalQty}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.ratePerKg.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.discount.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.rateAfterDiscount.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.taxableAmt.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{(item.sgstAmt + item.cgstAmt).toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.netAmt.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                        
                                        {selectedCustomerData && selectedCustomerData.length > 0 && (
                                            <tr>
                                                <td className="px-4 py-2 border-r" colSpan="2" style={{ fontSize: '12px', fontWeight: 'bold' }}>Total</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + item.quantity, 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + item.totalQty, 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + item.ratePerKg, 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + item.discount, 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + item.rateAfterDiscount, 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + item.taxableAmt, 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.sgstAmt + item.cgstAmt), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + item.netAmt, 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody> */}
                                    <tbody>
                                        {selectedCustomerData && selectedCustomerData.map((item, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{index + 1}</td>
                                                <td className="px-4 py-2 border-r" style={{ fontSize: '12px' }}>{item.item}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.quantity || 0}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>{item.totalQty || 0}</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.ratePerKg ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.discount ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.rateAfterDiscount ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.taxableAmt ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {/* {((item.sgstAmt ?? 0) + (item.cgstAmt ?? 0)).toFixed(2)} */}
                                                    {(item.gstAmt ?? 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '13px' }}>
                                                    {(item.netAmt ?? 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        ))}
                                        {selectedCustomerData && selectedCustomerData.length > 0 && (
                                            <tr>
                                                <td className="px-4 py-2 border-r" colSpan="2" style={{ fontSize: '12px', fontWeight: 'bold' }}>Total</td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.quantity || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.totalQty || 0), 0)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.ratePerKg || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.discount || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.rateAfterDiscount || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.taxableAmt || 0), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {/* {selectedCustomerData.reduce((sum, item) => sum + ((item.sgstAmt || 0) + (item.cgstAmt || 0)), 0).toFixed(2)} */}
                                                    {selectedCustomerData.reduce((sum, item) => sum + ((item.gstAmt || 0)), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right" style={{ fontSize: '12px' }}>
                                                    {selectedCustomerData.reduce((sum, item) => sum + (item.netAmt || 0), 0).toFixed(2)}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </TableContainer>

                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default DashboardSaleInvoice;


